/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { PinchZoomEnabler } from "./PinchZoomEnabler";
import { isPointInsideDocumentView } from "selectors/documentViewSelectors";

class TouchPinchZoomEnabler extends PinchZoomEnabler {
  constructor() {
    super();
    this.initialTouchArea = 0;
    this.initialZoomLevel = 1;
  }

  getNewZoomLevel(event, oldZoomLevel) {
    if (event.touches && event.touches.length === 2) {
      return (this.getTouchArea(event) / this.initialTouchArea) * this.initialZoomLevel;
    }
    return oldZoomLevel;
  }

  setScaleFactor(event, initialZoomLevel) {
    this.initialTouchArea = this.getTouchArea(event);
    this.initialZoomLevel = initialZoomLevel;
  }

  getCenterX(event) {
    let centerX = 0;
    if (event.touches.length === 2) {
      centerX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
    }
    return centerX;
  }

  getCenterY(event) {
    let centerY = 0;
    if (event.touches.length === 2) {
      centerY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
    }
    return centerY;
  }

  shouldStartPinchZoom(event, stores) {
    return (
      event.touches.length === 2 &&
      isPointInsideDocumentView(stores, event.touches[0].clientX, event.touches[0].clientY) &&
      isPointInsideDocumentView(stores, event.touches[1].clientX, event.touches[1].clientY)
    );
  }

  getTouchArea(event) {
    return Math.abs(
      (event.touches[0].clientX - event.touches[1].clientX) * (event.touches[0].clientY - event.touches[1].clientY)
    );
  }

  isEventToBeConsumendByEnabler({ type }) {
    return type.startsWith("touch");
  }
}

export { TouchPinchZoomEnabler };
